import { html, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { customElement } from 'lit/decorators.js';

import { PopBaseComponent } from '../../base/pop-base-component.js';
import type { ExampleUsageContentObject } from './example-usage.model.js';
import style from './example-usage.scss?inline';
import { Constants } from './example-usage.constants.js';
import { beaconTestContent } from '../../base/base.model.mock.js';

/**
 * @tag pop-example-usage-component
 * @attribute {ExampleUsageContentObject} [data-component-object] Example usage content
 * @slot content - contains example usage content
 */
@customElement(Constants.TAG_NAME)
export class ExampleUsage extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * The component object that contains the pre-fetched data to be rendered.
   */
  componentObject?: ExampleUsageContentObject;

  constructor() {
    super();
  }

  beaconTable() {
    return html`
      <beacon-table>
        <table>
          <thead>
            <tr>
              <th>
                <beacon-table-header action-zone=""
                  >Header 1</beacon-table-header
                >
              </th>
              <th>
                <beacon-table-header action-zone=""
                  >Header 2</beacon-table-header
                >
              </th>
              <th>
                <beacon-table-header action-zone=""
                  >Header 3</beacon-table-header
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Data 1</td>
              <td>Data 2</td>
              <td>Data 3</td>
            </tr>
          </tbody>
        </table>
      </beacon-table>
    `;
  }

  render() {
    return this.renderComponent(
      html`
        <h1>${unsafeHTML(this.componentObject?.title)}</h1>
        ${unsafeHTML(beaconTestContent('shadowdom beacon content'))}
        <div
          class="b-container b-padding-block-start--macro--mini b-padding-block-end--macro--mini"
        >
          <beacon-tooltip
            placement="top"
            opens-by="#example-tooltip-1"
            class=""
            motion-state="disabled"
            ><p>
              Example tooltip 1
              <beacon-icon name="support" size="s"></beacon-icon></p
          ></beacon-tooltip>
          <beacon-tooltip
            placement="top"
            opens-by="#example-tooltip-2"
            class=""
            motion-state="disabled"
            ><p>
              Example tooltip 2
              <beacon-icon name="dashboard" size="s"></beacon-icon></p
          ></beacon-tooltip>
          <beacon-popover
            placement="top"
            opens-by="#example-tooltip-3"
            class=""
            motion-state="disabled"
            ><h2>Popover</h2>
            ${this.beaconTable()}</beacon-popover
          >

          <beacon-icon-button
            id="example-tooltip-1"
            class="tooltip-icon-button"
            variant="primary"
          >
            Tooltip label
            <beacon-icon name="filetype_pdf_icon" size="s"></beacon-icon>
          </beacon-icon-button>
          <beacon-button id="example-tooltip-3" variant="primary">
            Tooltip with table
          </beacon-button>
          <h3>Slot content below</h3>
          <slot name="content"></slot>
        </div>
      `,
      this.componentObject?.popClasses || '',
    );
  }
}
